import React from 'react';
interface BreakdownLine {
  label: string;
  value: string;
}
interface ValueBreakdownProps {
  lines: BreakdownLine[];
  totalLabel: string;
  totalValue: string;
  finalPrice: string;
  discountPercent: string;
  priceTone?: 'white' | 'lime';
}
export function ValueBreakdown({
  lines,
  totalLabel,
  totalValue,
  finalPrice,
  discountPercent,
  priceTone = 'white'
}: ValueBreakdownProps) {
  return <div className="mb-6 rounded-xl border border-mp-border bg-mp-black/40 p-5" data-id="element-356" data-mp="2nvh3o3wnubej">
      <ul className="space-y-1.5" data-id="element-357" data-mp="2su24o5jqkz41">
        {lines.map(line => <li key={line.label} className="flex items-baseline gap-2 text-sm text-mp-gray" data-id="element-358" data-mp="2sr66cg3z88f2">
            <span className="whitespace-nowrap" data-id="element-359" data-mp="2dycio7ejwlzb">{line.label}</span>
            <span className="flex-1 border-b border-dotted border-mp-border" aria-hidden="true" data-id="element-360" data-mp="2iu1ga570fssz" />
            <span className="whitespace-nowrap" data-id="element-361" data-mp="12gbex679zin1">{line.value}</span>
          </li>)}
      </ul>

      <div className="my-3 h-px bg-mp-border" data-id="element-362" data-mp="17gz55pnojvg7" />

      <div className="flex items-baseline justify-between text-sm text-mp-gray" data-id="element-363" data-mp="13wnmmmf1i3ow">
        <span data-id="element-364" data-mp="13yibucxcghys">{totalLabel}</span>
        <span className="whitespace-nowrap line-through decoration-mp-gray/70" data-id="element-365" data-mp="yy40akwjapw0">{totalValue}</span>
      </div>

      <div className="mt-4 border-t border-mp-border pt-4" data-id="element-366" data-mp="1cxlujfslmvcr">
        <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-367" data-mp="1cuzgqyf47jm3">Precio de lanzamiento</p>
        <div className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-368" data-mp="1mv9s0dhlagym">
          <span className={`font-heading text-4xl ${priceTone === 'lime' ? 'text-mp-lime' : 'text-mp-white'} sm:text-5xl`} data-id="element-369" data-mp="1mtf892i20uw4">
            {finalPrice}
          </span>
          <span className="font-heading text-sm font-semibold uppercase text-mp-lime" data-id="element-370" data-mp="1vn21olyshm25">
            (Descuento del {discountPercent})
          </span>
        </div>
      </div>
    </div>;
}